import { APIResponse } from '@/types';
import httpService from './httpService';
import { ProjectInfoResponse } from '@/types/pages/projectInfo';

export function fetchProjectInfoAPI(): APIResponse<ProjectInfoResponse> {
    return httpService.get('/version');
}
